"use client";

import { useEffect, useState } from "react";
import { useTranslation } from "@/lib/i18n/context";
import { regionFromGeo, type ConsentRegion } from "@/lib/consent/regions";
import { getConsentProfile } from "@/lib/consent/profiles";
import { REGION_COOKIE_NAME } from "@/lib/consent/version";
import { triggerDoNotSell } from "./CookieConsent";

function readCookie(name: string): string | null {
  if (typeof document === "undefined") return null;
  const m = document.cookie.match(new RegExp("(?:^|; )" + name.replace(/[$()*+./?[\\\]^{|}]/g, "\\$&") + "=([^;]*)"));
  return m ? decodeURIComponent(m[1]) : null;
}

export function DoNotSellLink({ className }: { className?: string }) {
  const { t } = useTranslation();
  const [show, setShow] = useState(false);

  useEffect(() => {
    const region = (readCookie(REGION_COOKIE_NAME) as ConsentRegion | null) || regionFromGeo(null, null);
    const profile = getConsentProfile(region);
    setShow(profile.showDoNotSell);
  }, []);

  if (!show) return null;
  return (
    <button
      type="button"
      onClick={() => triggerDoNotSell()}
      className={className ?? "text-[var(--ink-soft)] hover:text-[var(--terracotta)] underline-offset-2 hover:underline"}
    >
      {t.consent.banner.doNotSell}
    </button>
  );
}
